import {
  canSaveDrawerCount,
  amountForNewDrawerSalesLine,
  reconcileDrawerSalesAmountsForDay,
  type CashbookEntryRecord
} from '@finvox/shared/cashbook';
import { roundMoney } from '@finvox/shared/money';
import type { Transaction } from 'firebase/firestore';
import { doc } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';
import { cashbookEntriesCol } from './context';

/**
 * After mutating outs for `date`, refresh Path A sales amounts if drawer-origin
 * sales lines exist. Expenses are hosted once on the earliest line (by id).
 * Pass entries that already include the mutation effect (or exclude the voided id).
 */
export function applyDrawerSalesRefreshInTx(
  tx: Transaction,
  db: Firestore,
  orgId: string,
  date: string,
  entries: CashbookEntryRecord[]
): void {
  const updates = reconcileDrawerSalesAmountsForDay(entries, date);
  for (const u of updates) {
    const ref = doc(cashbookEntriesCol(db, orgId), u.entryId);
    tx.update(ref, { amount: roundMoney(u.amount) });
  }
}

export function assertDrawerCountAllowed(entries: CashbookEntryRecord[], date: string): void {
  const decision = canSaveDrawerCount(entries, date);
  if (decision.action === 'block') {
    if (decision.reason === 'payvox') {
      throw new Error('PayVox sales already recorded — void it first to use Amount in drawer');
    }
    throw new Error('Manual sales already recorded — void it first to use Amount in drawer');
  }
}

export { amountForNewDrawerSalesLine };
